<!--relateUserDialog 关联用户-->
<template>
  <el-drawer
    class="sideDrawer"
        destroy-on-close
:size="drawerSize"
    :close-on-click-modal="false"
    title="关联用户"
    :visible="show"
    :before-close="beforeCloseDialog"
    @dialogclose="beforeCloseDialog"
    append-to-body
  ><i
      class="iconfont icon-back-quanping iconFull"
      @click="drawerSize = '100%'"
      v-if="drawerSize == '70%'"
    />
    <i
      @click="drawerSize = '70%'"
      class="iconfont icon-back-tuichuquanping iconFull"
      v-else
    />
    <div
      slot="title"
      class="dialog-header-title"
    >
      <span
        class="name"
        style="font-size: 16px;font-weight: bold"
      >关联用户</span>
    </div>
    <div
      class="form_content"
      style="padding: 20px"
    >
      <div
        ref="tablePanel"
        class="fullheight"
      >
        <div class="table_content">
          <div class="button_group">
            <div>
              （已关联 {{ total }} 个账户，最多可以绑定
              {{ tempValue.total_user }} 个账户,还可以绑定
              {{ tempValue.total_user - total }} 个账户）
            </div>
            <el-button
              type="primary"
              @click="showAddUser()"
            >添加关联用户</el-button>
          </div>
          <el-table
            ref="ecoTable"
            :style="{
              height: `${tableMaxHeight}` + 'px'
            }"
            :max-height="tableMaxHeight"
            :data="templateData"
            tooltip-effect="dark"
            style="width: 100%"
            border
            :header-cell-style="headerCellStyle"
          >
            <el-table-column
              type="index"
              label="序号"
              width="55"
            >
            </el-table-column>
            <el-table-column
              prop="full_name"
              label="用户名称"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="account"
              label="账号"
            > </el-table-column>
            <el-table-column
              prop="email"
              label="邮箱"
            > </el-table-column>
            <el-table-column
              prop="mobile"
              label="电话"
            > </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  @click="temCancel(scope.row.id)"
                >取消关联</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="page_bean">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-sizes="[10, 20, 40, 50, 100, 500]"
              :page-size.sync="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 用户选择器 -->
    <eip-user-dialog
      ref="eipUserDialog"
      @onConfirm="userDialogOnConfirm"
      :single="false"
      :userType="true"
      append-to-body
    />
  </el-drawer>
</template>

<script>
import form from '@/api/form'
import EipUserDialog from '@/components/dialog/EipUserDialog.vue'
export default {
  name: 'billRecordDialog',
  components: {
    EipUserDialog
  },
  data() {
    return {
      drawerSize: '70%',
      total: 0,
      pageSize: 20,
      currentPage: 1,
      templateData: [],
      boDefIdList: [],
      selectUploadId: null,
      selectModel: null,
      taVisible: false,
      tmVisible: false,
      tableMaxHeight: 400,
      activeName: 'first',
      code: ''
    }
  },
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    tempValue: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.loadData()
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.loadData()
        }
      },
      deep: true
    }
  },
  methods: {
    beforeCloseDialog() {
      this.$emit('closeRelateUser')
    },
    showAddUser() {
      if (this.tempValue.total_user - this.total > 0) {
        this.$refs.eipUserDialog.showDialog()
      } else {
        this.$message({
          type: 'error',
          message: '剩余使用用户为0, 不能添加'
        })
      }
    },
    temCancel(id) {
      this.$confirm('此操作将取消关联此用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: id
        }
        form.getRemoveRelateUser(params).then((res) => {
          if (res.state) {
            this.$message.success('操作成功')
            this.loadData()
          }
        })
      })
    },
    //表头样式
    headerCellStyle() {
      return {
        textAlign: 'center',
        backgroundColor: '#F3F3F3',
        color: '#333333'
      }
    },
    //每页数量调整
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    //页数跳转
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    // 动态计算表格的高度，自适应当前容器
    calcTableHeight(delay) {
      setTimeout(() => {
        if (!this.$refs.tablePanel) {
          return
        }
        const tablePanelHeight = this.$refs.tablePanel.$el.clientHeight
        this.tableMaxHeight = tablePanelHeight - 220
      }, delay || 0)
    },
    // 用户选择器回显
    userDialogOnConfirm(selection) {
      if (selection && selection.length > 0) {
        let params = selection.map((item) => {
          item['refId'] = this.tempValue.id
          item['account_module'] = this.tempValue.account_module
          item['er_id'] = item.id
          item['full_name'] = item.fullname
          return item
        })
        form.getAddRelateUser(params).then((res) => {
          if (res.state) {
            this.$message.success('操作成功')
            this.loadData()
          }
        })
      }
    },
    //初始化加载
    loadData(prop, sort) {
      let params = {
        pageBean: {
          page: this.currentPage,
          pageSize: this.pageSize,
          total: 0
        }
      }
      let subParams = {
        accountId: this.tempValue.account_module
      }
      if (prop) {
        params.sorter = [{ property: prop, direction: sort }]
      }
      form.getRelateUserList(params, subParams).then((resp) => {
        this.templateData = resp.rows
        this.total = resp.total
      })
    }
  }
}
</script>

<style scoped>
.page_bean {
  text-align: right;
}
.button_group {
  display: flex;
  justify-content: space-between;
}
</style>
